module.exports = {
          srcSet: __webpack_public_path__ + "a458bebe1cef41b6b90f4a7be302b5c1-909.png"+" 909w",
          images:[ {path: __webpack_public_path__ + "a458bebe1cef41b6b90f4a7be302b5c1-909.png",width: 909,height: 308}],
          src: __webpack_public_path__ + "a458bebe1cef41b6b90f4a7be302b5c1-909.png",
          toString:function(){return __webpack_public_path__ + "a458bebe1cef41b6b90f4a7be302b5c1-909.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAIAAAAlXwkiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAZElEQVR4nGO4dnDqsRlupxd5fz8/6e2v/z9+/f6PBBgurqs9vtjn4grHl/uK9977cObRuyfvvz37+P3umy+P3n9jOHt05ubF1ld3V/z58uLd979PP3x7+P7b6y8/H73/+uLTdwBEKUruJRe8+gAAAABJRU5ErkJggg==",
          width: 909,
          height: 308
        }